import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import Filters from '../../components/Filters/Filters';
import Text from '../../components/Inputs/Text/Text';
import SelectOption from '../../components/Inputs/Select/Select';
import DependenciaAdministrativa from '../DependenciaAdministrativa/DependenciaAdministrativaFilter';

import EnumService from '../../services/Enum';

import { removePagingAndSorting } from '../../helper/PaginationHelper';

export class DocumentoFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                codigo: '',
                nome: '',
	            status: '',
                tipoDocumento: '',
            },
            count: 0,
            optionsTiposDocumento: [], 
            optionsStatusValidacao: [],
        };
    }

    setDependenciaAdministrativa = form => this.DependenciaAdministrativa = form;

    // INPUTS
    handleChange = e => {
        this.setState({
            filters: { ...this.state.filters, [e.target.name]: e.target.value }
        });
    };

    // APLICAR PERSISTENCIA
    handleFilterPersistence = (filters) => {
        filters = removePagingAndSorting(filters);

        this.setState({
            filters: {
                codigo: filters.find(f => f.field === 'codigo') ? filters.find(f => f.field === 'codigo').value : "",
                nome: filters.find(f => f.field === 'nome') ? filters.find(f => f.field === 'nome').value : "",
                status: filters.find(f => f.field === 'status') ? filters.find(f => f.field === 'status').value : "",
                tipoDocumento: filters.find(f => f.field === 'tipoDocumento') ? filters.find(f => f.field === 'tipoDocumento').value : "",
            },
            count: filters.reduce((total, f) => f.value !== '' ? total + 1 : total, 0),
        })

        this.DependenciaAdministrativa.setState({
            filters: {
                adminDep: filters.find(f => f.field === 'dependenciaAdministrativa') ? filters.find(f => f.field === 'dependenciaAdministrativa').value : "",
            }
        })
    }

    // FILTROS
    handleFilterApply = () => {
        const f = [];
        const { filters } = this.state;
        const filtersDepAdmin = this.DependenciaAdministrativa.state.filters;
        
        if (filters.codigo !== '') f.push({ field: 'codigo', value: filters.codigo });
        if (filters.nome !== '') f.push({ field: 'nome', value: filters.nome });
        if (filters.status !== '') f.push({ field: 'status', value: filters.status });
        if (filters.tipoDocumento !== '') f.push({ field: 'tipoDocumento', value: filters.tipoDocumento });

        if (filtersDepAdmin.adminDep) f.push({ field: 'dependenciaAdministrativa', value: filtersDepAdmin.adminDep })

        this.props.handleFilterChange(f);
    }

    // LIMPAR FILTROS
    handleFilterClear = () => {
        this.setState({
             filters: {
                codigo: '',
                nome: '',
	            status: '',
                tipoDocumento: '',
            },
            count: 0,
        });

        this.DependenciaAdministrativa.setState({
            filters: {
                adminDep: '',
            }
        })

        this.props.handleFilterChange([], false);
    }

    // CONTAGEM DE FILTROS ATIVOS
    handleCountFilters = () => this.state.count;

    async componentDidMount() { 
        const tiposDocumento = await EnumService.listarTiposDocumento().then(res => res.data);
        const statusValidacao = await EnumService.listarStatusValidacao().then(res => res.data);

        this.setState({ 
            ...this.state, 
            optionsTiposDocumento: [...tiposDocumento.map(tp => { return { label: tp.nome, value: tp.id }; })], 
            optionsStatusValidacao: [...statusValidacao],
        });
     }

    render() {
        return (
            <Filters
                handleFilter={this.handleFilterApply}
                handleFilterClear={this.handleFilterClear}
                countFilters={this.handleCountFilters}
            >
                <Grid item container spacing={4}>
                    <Grid item sm={12} lg={2}>
                        <Text
                            label="Código do Candidato"
                            name='codigo'
                            value={this.state.filters.codigo}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </Grid>
                     <Grid item sm={12} lg={5}>
                        <Text
                            label="Nome do Candidato"
                            name='nome'
                            value={this.state.filters.nome}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </Grid>
                </Grid>
                
                <Grid item container spacing={4}>
                    <Grid item sm={12} lg={4}>
                        <SelectOption
                            label="Status de Validação"
                            name='status'
                            value={this.state.filters.status}
                            options={this.state.optionsStatusValidacao}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </Grid>
                    
                    <DependenciaAdministrativa
                        parentRef={this.setDependenciaAdministrativa}
                        withPublicGroup={true}
                    />

                    <Grid item sm={12} lg={2}>
                        <SelectOption
                            label="Tipo de Documento"
                            name='tipoDocumento'
                            value={this.state.filters.tipoDocumento}
                            options={this.state.optionsTiposDocumento}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </Grid>
                </Grid>
            </Filters>
        )
    }
}

export default DocumentoFilter;